var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-case-declarations */
import { ErrorCode, User, DEFAULT_AGENT_ID, KEY_SESSION_CODE, WIDGET_REFERRER_ID, WIDGET_CONVERSATION_TYPE, WIDGET_MODE, OriginModeEnum, } from "./models";
import debug from "debug";
import ky from "ky";
import { codeError } from "./utils";
import { sessionStore } from "@auvious/utils";
import { Util, } from "@auvious/common";
import { DCEventTypeEnum, } from "./models/digitalConnect";
import { Restorable } from "./models/Restorable";
const log = debug("auvious:integrations");
export class DigitalConnectService extends Restorable {
    constructor(config, handlers, commonClient, authClient) {
        var _a, _b;
        super([KEY_SESSION_CODE]);
        this.config = config;
        this.handlers = handlers;
        this.commonClient = commonClient;
        this.authClient = authClient;
        this.attachmentConstraints = null;
        this.isConversationEnded = false;
        this.baseUrl = "https://" + config.auviousEnvironment;
        this.setupCommonClient();
        (_b = (_a = this.handlers).ready) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    endConversation(conversationId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield ky.delete(`api/digital-connect/talkdesk/conversations/${conversationId}`, {
                    prefixUrl: this.baseUrl,
                    headers: {
                        Authorization: `Bearer ${this.commonClient.auth.token.accessToken}`,
                    },
                });
            }
            catch (ex) {
                throw codeError(ex, ErrorCode.DIGITAL_CONNECT_API_ERROR);
            }
        });
    }
    sendConversationMessage(conversationId, content) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const message = yield ky
                    .post(`api/digital-connect/talkdesk/conversations/messages`, {
                    json: {
                        conversationId,
                        content,
                    },
                    prefixUrl: this.baseUrl,
                    headers: {
                        Authorization: `Bearer ${this.commonClient.auth.token.accessToken}`,
                    },
                })
                    .json();
                return message;
            }
            catch (ex) {
                throw codeError(ex, ErrorCode.DIGITAL_CONNECT_API_ERROR);
            }
        });
    }
    getConversationMessages(conversationId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const messages = yield ky
                    .get(`api/digital-connect/talkdesk/conversations/${conversationId}/messages`, {
                    prefixUrl: this.baseUrl,
                    headers: {
                        Authorization: `Bearer ${this.commonClient.auth.token.accessToken}`,
                    },
                })
                    .json();
                return messages;
            }
            catch (ex) {
                throw codeError(ex, ErrorCode.DIGITAL_CONNECT_API_ERROR);
            }
        });
    }
    parseConversationMessages(messages = []) {
        messages.forEach((message) => {
            var _a, _b;
            const msg = {
                id: message.messageId,
                senderId: message.author === "CUSTOMER" ? this.me.id : DEFAULT_AGENT_ID,
                senderName: message.name,
                text: message.content,
                type: "text",
                isLocal: message.author === "CUSTOMER",
                status: "ack",
                timestamp: new Date(message.created),
            };
            (_b = (_a = this.handlers).messageReceived) === null || _b === void 0 ? void 0 : _b.call(_a, msg);
        });
    }
    handleMessageEvent(event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        if (((_a = event === null || event === void 0 ? void 0 : event.payload) === null || _a === void 0 ? void 0 : _a.type) === "KeepAliveReminder") {
            return;
        }
        let typedPayload;
        /**
        DCEndingEvent customer ends conversation
        DCEndedEvent agent ends conversation & disposition
         */
        switch ((_b = event === null || event === void 0 ? void 0 : event.payload) === null || _b === void 0 ? void 0 : _b.type) {
            case DCEventTypeEnum.ending:
                // typedPayload = event.payload as IDCEndingEvent;
                if (!this.isConversationEnded) {
                    (_d = (_c = this.handlers).agentLeft) === null || _d === void 0 ? void 0 : _d.call(_c);
                    (_f = (_e = this.handlers).ended) === null || _f === void 0 ? void 0 : _f.call(_e);
                    this.isConversationEnded = true;
                }
                break;
            case DCEventTypeEnum.ended:
                (_h = (_g = this.handlers).customerLeft) === null || _h === void 0 ? void 0 : _h.call(_g);
                (_k = (_j = this.handlers).agentLeft) === null || _k === void 0 ? void 0 : _k.call(_j);
                (_m = (_l = this.handlers).ended) === null || _m === void 0 ? void 0 : _m.call(_l);
                break;
            case DCEventTypeEnum.messageReceived:
                typedPayload = event.payload;
                const msg = {
                    id: typedPayload.eventId,
                    senderId: DEFAULT_AGENT_ID,
                    text: typedPayload.content,
                    type: "text",
                    isLocal: false,
                    timestamp: new Date(typedPayload.timestamp),
                    status: "ack",
                };
                (_p = (_o = this.handlers).messageReceived) === null || _p === void 0 ? void 0 : _p.call(_o, msg);
                break;
            case DCEventTypeEnum.started:
                typedPayload = event.payload;
                const agent = {
                    id: DEFAULT_AGENT_ID,
                    joinDate: typedPayload.timestamp,
                    displayName: "Agent",
                    role: "AGENT",
                };
                (_r = (_q = this.handlers).agentJoined) === null || _r === void 0 ? void 0 : _r.call(_q, agent);
                break;
            case DCEventTypeEnum.roomCreated:
                typedPayload = event.payload;
                (_t = (_s = this.handlers).roomCreated) === null || _t === void 0 ? void 0 : _t.call(_s, typedPayload.url);
                break;
            case DCEventTypeEnum.cobrowseRequested:
                typedPayload = event.payload;
                (_v = (_u = this.handlers).cobrowseRequested) === null || _v === void 0 ? void 0 : _v.call(_u, typedPayload.ticket, typedPayload.properties.requestType || "view");
                break;
        }
    }
    setupCommonClient() {
        const handlers = {
            onConnected: () => { },
            onConnectedFailed: (event) => {
                throw event;
            },
            onMessageSent: () => { },
            onMessageReceived: this.handleMessageEvent.bind(this),
            onError: (event) => {
                throw event;
            },
        };
        if (!this.commonClient.eventsEnabled) {
            throw new Error("Internal error: events not enabled.");
        }
        if (!this.commonClient.eventsInitialized) {
            throw new Error("Internal error: events not initialized.");
        }
        if (this.subscription) {
            this.subscription.dispose();
        }
        this.subscription = this.commonClient.events.setEventHandlers(handlers);
    }
    reconnect(contact, conversationType) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const previousSession = sessionStore.getItem(KEY_SESSION_CODE);
                if (previousSession) {
                    const { authenticationCode } = JSON.parse(previousSession);
                    yield this.connect(contact, conversationType, authenticationCode);
                    // get history if any
                    const history = yield this.getConversationMessages(this.$conversation.id);
                    this.parseConversationMessages(history);
                    (_b = (_a = this.handlers).agentJoined) === null || _b === void 0 ? void 0 : _b.call(_a, {
                        id: DEFAULT_AGENT_ID,
                        joinDate: new Date().toISOString(),
                        displayName: "Agent",
                        role: "AGENT",
                    });
                }
            }
            catch (ex) {
                log.error(ex);
            }
        });
    }
    connect(contact, conversationType, authenticationCode) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __awaiter(this, void 0, void 0, function* () {
            this.isConversationEnded = false;
            try {
                (_b = (_a = this.handlers).starting) === null || _b === void 0 ? void 0 : _b.call(_a);
                (_d = (_c = this.handlers).connecting) === null || _d === void 0 ? void 0 : _d.call(_c);
                // try authenticate first
                const token = (yield this.authClient.authenticate(Object.assign(Object.assign({}, authenticationCode), { customProperties: Object.assign(Object.assign({}, authenticationCode.customProperties), { [WIDGET_REFERRER_ID]: window.origin, [WIDGET_CONVERSATION_TYPE]: conversationType, [WIDGET_MODE]: this.config.kioskMode
                            ? OriginModeEnum.kiosk
                            : OriginModeEnum.website }) })));
                this.me = new User(token);
                // create endpoint
                (_f = (_e = this.handlers).connected) === null || _f === void 0 ? void 0 : _f.call(_e);
                // accept conversation and start receiving messages
                const response = yield this.authClient.register();
                this.$members = Object.assign(Object.assign({}, this.$members), { [this.me.id]: {
                        id: this.me.id,
                        displayName: [contact === null || contact === void 0 ? void 0 : contact.firstName, contact === null || contact === void 0 ? void 0 : contact.lastName].join(" "),
                        joinDate: new Date().toISOString(),
                        role: "CUSTOMER",
                    } });
                this.$conversation = {
                    uri: null,
                    id: response.conversationId,
                    jwt: this.commonClient.auth.token.accessToken,
                    memberId: this.me.id,
                };
                (_h = (_g = this.handlers).started) === null || _h === void 0 ? void 0 : _h.call(_g, this.$conversation);
                sessionStore.setItem(KEY_SESSION_CODE, JSON.stringify({
                    authenticationCode,
                }));
            }
            catch (ex) {
                this.destroy();
                (_k = (_j = this.handlers).error) === null || _k === void 0 ? void 0 : _k.call(_j, ex);
                throw ex;
            }
        });
    }
    /** interface methods **/
    createChat(contact, conversationType, code) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.connect(contact, conversationType, code);
            (_b = (_a = this.handlers).agentNotified) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
    }
    endChat() {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                (_b = (_a = this.handlers).customerLeft) === null || _b === void 0 ? void 0 : _b.call(_a);
                yield this.endConversation((_c = this.$conversation) === null || _c === void 0 ? void 0 : _c.id);
            }
            catch (ex) {
                // we get 500 if the conversation was cloded previously by the agent.
            }
            if (!this.isConversationEnded) {
                (_e = (_d = this.handlers).agentLeft) === null || _e === void 0 ? void 0 : _e.call(_d);
                (_g = (_f = this.handlers).ended) === null || _g === void 0 ? void 0 : _g.call(_f);
                this.$conversation = undefined;
                this.isConversationEnded = true;
            }
        });
    }
    acknowledgeMessages() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    sendMessage(content, bodyType) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            let message = {
                id: Util.uuidgen(),
                senderId: this.me.id,
                text: content,
                type: "text",
                isLocal: true,
                status: "sent",
                timestamp: new Date(),
            };
            (_b = (_a = this.handlers).messageSent) === null || _b === void 0 ? void 0 : _b.call(_a, message);
            try {
                const response = yield this.sendConversationMessage(this.$conversation.id, content);
                // we don't get an event for our own messages
                message = Object.assign(Object.assign({}, message), { id: response.messageId, status: "ack" });
                (_d = (_c = this.handlers).messageReceived) === null || _d === void 0 ? void 0 : _d.call(_c, message);
            }
            catch (ex) {
                message = Object.assign(Object.assign({}, message), { status: "error" });
                (_f = (_e = this.handlers).messageError) === null || _f === void 0 ? void 0 : _f.call(_e, message);
            }
        });
    }
    sendTyping() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    sendFile(inputFileRef) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    downloadFile(file) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    customerConnected() {
        return __awaiter(this, void 0, void 0, function* () {
            return !!this.me;
        });
    }
    destroy() {
        sessionStore.removeItem(KEY_SESSION_CODE);
        this.authClient.logout();
    }
}
